import axios from 'axios'
import router from '../router'
import CryptoJS from 'crypto-js';
import UUID from 'uuid-js';
const TIME_OUT_MS = 30 * 1000 // 默认请求超时时间

// 环境的切换
// if (process.env.NODE_ENV === 'debug') {
// 	axios.defaults.baseURL = '/api';
// } else {
//   axios.defaults.baseURL = process.env.SERVER_URL;
// }

if (process.env.NODE_ENV === 'debug') {
  // 加载本地调试接口地址
  let config;
  try {
    config = require('../../.httpconfig.js').default;
  } catch (e) {
    config = {
      SERVER_URL: process.env.SERVER_URL
    };
  }
  axios.defaults.baseURL = config.SERVER_URL;
} else {
  axios.defaults.baseURL = process.env.SERVER_URL;
}

//请求地址
function handleUrl(url) {
	return url
}

// 添加请求拦截器--
axios.interceptors.request.use(function(config) {

	return config
}, function(error) {
	console.log(error)
	// 对请求错误做些什么
	return Promise.reject(error)
});

// 添加响应拦截器
axios.interceptors.response.use(function(response) {
	return response
}, function(error) {
console.log(error)
	return Promise.reject(error)
});

//参数
function handleParams(data) {
	var publicdata = {
		//公参
		"appid": "3001",
		"appver": "1.0.0",
		"cid": "",
		"token": localStorage.getItem('token'),
		"ts": (new Date()).getTime(), //当前毫秒
		"uid": localStorage.getItem('uid'),
		//业务参数
		"data": data
	}
	return publicdata
}
/*
 * @param response 返回数据列表
 */
function handleResults(response) {
	var result = {
		success: false,
		message: '',
		errorCode: '',
		data:[],
		code:''
	}
	result.data = response.data.data
	result.message = response.data.msg
	result.code = response.data.code
	return result
}

export default {
	/*
	 * @param url
	 * @param data
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */

	post(url, data, response, exception) {

    let uuid = UUID.create().toString();
    // let keys = Object.keys(data).sort();
    // let values = '';
    // keys.forEach(key => {
    //   values += typeof data[key] === "undefined" ? '' : data[key];
    // });
		axios({
			method: 'post',
			url: handleUrl(url),
			data: data,
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				"appid": "3001",
				"appver": "1.0.0",
				"cid": "",
				"token": localStorage.getItem('token'),
				"ts": (new Date()).getTime(), //当前毫秒
				// "uid": localStorage.getItem('uid'),
        'nonce': uuid,
        'signature': CryptoJS.HmacSHA1(JSON.stringify(data) + uuid, 'hnmesjitixesl9mv').toString()
        // 'signature': CryptoJS.HmacSHA1(values + uuid, 'hnmesjitixesl9mv').toString()
			}
		}).then(
			(result) => {
				response(handleResults(result))
			}
		).catch(
			(error) => {
				console.log(error)
				if (exception) {
					exception(error)
				} else {
					console.log(error)
				}
			}
		)
	},

	/*
	 * 导入文件
	 * @param url
	 * @param data
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */
	uploadFile(url, data, response, exception) {
		axios({
			method: 'post',
			url: handleUrl(url),
			data: handleParams(data),
			dataType: 'json',
			processData: false,
			contentType: false
		}).then(
			(result) => {
				response(handleResults(result, data))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					console.log(error)
				}
			}
		)
	},
	/*
	 * 下载文件用，导出 Excel 表格可以用这个方法
	 * @param url
	 * @param param
	 * @param fileName 如果是导出 Excel 表格文件名后缀最好用.xls 而不是.xlsx，否则文件可能会因为格式错误导致无法打开
	 * @param exception 异常的回调函数
	 */
	downloadFile(url, data, fileName, exception) {
		axios({
			method: 'post',
			url: handleUrl(url),
			data: handleParams(data),
			responseType: 'blob'
		}).then(
			(result) => {
				const excelBlob = result.data
				if ('msSaveOrOpenBlob' in navigator) {
					// Microsoft Edge and Microsoft Internet Explorer 10-11
					window.navigator.msSaveOrOpenBlob(excelBlob, fileName)
				} else {
					const elink = document.createElement('a')
					elink.download = fileName
					elink.style.display = 'none'
					const blob = new Blob([excelBlob])
					elink.href = URL.createObjectURL(blob)
					document.body.appendChild(elink)
					elink.click()
					document.body.removeChild(elink)
				}
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					console.log(error)
				}
			}
		)
	},
	uploadFileFormData(url, data, response, exception) {
		axios({
			method: 'post',
			url: handleUrl(url),
			data: data,
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then(
			(result) => {
				response(handleResults(result))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					console.log(error)
				}
			}
		)
	}
}



// WEBPACK FOOTER //
// ./src/utils/http.js